module.exports = __webpack_public_path__ + "assets/chevin-light.3d61255d2717ded0c55bdb7d35939d60.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/OP/chevin-light.woff
// module id = 133
// module chunks = 0